import { render, staticRenderFns } from "./TelBlock.vue?vue&type=template&id=c8ae5700&"
import script from "./TelBlock.vue?vue&type=script&lang=js&"
export * from "./TelBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports